import React from 'react';
import '../styles/ContactMe.css';

const ContactMe = () => {
    React.useEffect(()=>{
        document.getElementsByTagName('title')[0].innerHTML='Ainsley Davis 2026 - Contact Me';
    },[])
    const handleSubmit = (event) => {
        event.preventDefault(); // Prevents the default form submission behavior

        // Collect form data
        const formData = {
            name: event.target.name.value,
            email: event.target.email.value,
            subject: event.target.subject.value,
            message: event.target.message.value,
        };
        console.log(JSON.stringify(formData, null, 2));

        const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfV0alEeLrBhkSHUcGj2Sc2FWX0lISiKUIOznG7sMQQv4wkjg/formResponse';


        const urlEncodedData = new URLSearchParams({
            'entry.1223360331': formData.name,      // Replace with your "Name" field entry ID
            'entry.2083961632': formData.email,     // Replace with your "Email" field entry ID
            'entry.1115304828': formData.subject,   // Replace with your "Subject" field entry ID
            'entry.2015655816': formData.message,   // Replace with your "Message" field entry ID
        });

        // Submit form data to Google Forms
        fetch(formUrl, {
            method: 'POST',
            mode: 'no-cors', // Avoids CORS issues with Google Forms
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: urlEncodedData,
        })
            .then(() => {
                alert('Your message has been sent!');
            })
            .catch((error) => {
                console.error('Error submitting the form:', error);
                alert('There was an error. Please try again.');
            });
    };

    return (
        <div className="floating-container">
            <h1 className="contact-title">Contact Me</h1>
            <div className="contact-info">
                <p>If you would like to get in touch, please fill out the form below or contact me directly using the information provided.</p>
                <p  style={{userSelect:'text'}}><strong>Email:</strong> ainsley8mdavis@gmail.com</p>
                <p style={{userSelect:'text'}}><strong>Phone:</strong> (707) 241-0045</p>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" name="name" required />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" required />
                </div>
                <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input type="text" id="subject" name="subject" required />
                </div>
                <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea id="message" name="message" rows="6" required></textarea>
                </div>
                <button type="submit" className="contact-button">Send Message</button>
            </form>
        </div>
    );
};

export default ContactMe;
